import { Component, Input } from '@angular/core';

import { TermsComponent } from '../../terms.component';

/**
 * "the_portrait" view of /terms — a full page rather than the default theme's modal.
 *
 * Purely presentational: every field and handler comes from the page component via `host`,
 * including the legal copy itself (host.termsBody), so there is exactly one copy of the text.
 */
@Component({
  selector: 'app-terms-portrait',
  templateUrl: './terms-portrait.component.html',
  styleUrls: ['./terms-portrait.component.scss']
})
export class TermsPortraitComponent {

  @Input() host!: TermsComponent;

}
